import React, { useState, useEffect } from 'react';
import { apis, apiHolder as api } from 'api';
import { dateFormat, getWeekdayText } from '../../util';
import './index.scss';
import SiriusTable from '@web-common/components/UI/Table';
import { ConfigProvider } from 'antd';
import { getIn18Text } from 'api';
import debounce from 'lodash/debounce';
import MailCardStateIcon from '@web-mail/common/components/vlistCards/MailCard/MailCardStateIcon';
import Button from '@web-common/components/UI/Button';
import Tooltip from '@lingxi-common-component/sirius-ui/Tooltip';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const MailDeliveryHistory = ({ mid, content, forwarded, replyed }) => {
    const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
    const [visible, setVisible] = useState(false);
    const [readListData, setReadListData] = useState();
    const [sendText, setSendText] = useState('');
    const [loading, setLoading] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const DeliveryMap = {
        0: getIn18Text('YIHUIFU'),
        6: getIn18Text('YIZHUANFA'),
        7: getIn18Text('YIZHUANFA'),
        8: getIn18Text('YIZHUANFA'),
        2: getIn18Text('YIHUIFU'),
        3: getIn18Text('YIHUIFU'),
        4: getIn18Text('YIHUIFU'),
    };
    const descText = forwarded && replyed ? getIn18Text('YOUJIANYIBEIZHUANFQHF') : forwarded ? getIn18Text('YOUJIANYIBEIZHUANF') : getIn18Text('YOUJIANYIBEIHUIF');
    const collectData = (data) => {
        try {
            if (data === null || data === void 0 ? void 0 : data.length) {
                const map = new Map();
                data.forEach(obj => {
                    if (!obj.originModtime) {
                        obj.originModtime = obj.modifiedTime;
                    }
                    if (map.has(obj.msgid)) {
                        map.get(obj.msgid).email.push(obj.email);
                    }
                    else {
                        map.set(obj.msgid, Object.assign(Object.assign({}, obj), { email: [obj.email] }));
                    }
                });
                return Array.from(map.values());
            }
            return [];
        }
        catch (error) {
            console.error('collectData delivery history data error', error);
            return [];
        }
    };
    const refreshData = debounce(() => {
        setLoading(true);
        mailApi
            .doCheckReadStatus(mid, content._account || '', true)
            .then(data => {
            if (data.detail.length) {
                setHistoryData(collectData(data.detail));
            }
        })
            .finally(() => {
            setLoading(false);
        });
    }, 1000, { leading: true, trailing: false });
    useEffect(() => {
        if (visible && historyData.length <= 0) {
            refreshData();
        }
    }, [visible]);
    useEffect(() => {
        setHistoryData([]);
        setVisible(false);
    }, [mid]);
    const tableColumns = [
        {
            title: () => React.createElement("span", { style: { marginLeft: -10 } }, getIn18Text('CHULIFANGSHI')),
            dataIndex: 'msgType',
            key: 'msgType',
            width: 149,
            align: 'left',
            render: (msgType) => {
                return React.createElement("span", { style: { marginLeft: -10 } }, DeliveryMap[msgType] || msgType);
            },
        },
        {
            title: getIn18Text('SHIJIAN'),
            dataIndex: 'originModtime',
            key: 'originModtime',
            width: 200,
            align: 'left',
            render: (time) => {
                const _time = dateFormat('YYYY-mm-dd HH:MM', time);
                return `${_time} (${getWeekdayText(new Date(_time))})`;
            },
        },
        {
            title: getIn18Text('LIANXIREN'),
            dataIndex: 'email',
            key: 'email',
            align: 'left',
            render: (emails) => {
                return emails.map((email, i) => (React.createElement(Tooltip, { placement: "top", title: email },
                    i !== 0 ? '、' : '', email === null || email === void 0 ? void 0 :
                    email.split('@')[0])));
            },
        },
    ];
    return (React.createElement("div", { onClick: e => {
            e.stopPropagation();
        } },
        React.createElement("div", { className: `m-sticky-history ${visible ? 'm-sticky-history-expanded' : ''}` },
            React.createElement("div", { className: "u-sticky" },
                React.createElement("div", { className: "u-sticky-content", "data-test-id": "read-status-tip-panel" },
                    React.createElement("span", { className: "u-sticky-icon" },
                        React.createElement(MailCardStateIcon, { data: content, active: true })),
                    React.createElement("span", { className: "u-sticky-title", "data-test-id": "read-status-tip-desc-span" }, descText),
                    React.createElement(Button, { btnType: "link", inline: true, "data-test-id": "read-status-tip-button", onClick: () => {
                            setVisible(!visible);
                        }, size: "small" }, visible ? getIn18Text('YINCANGXIANGQING') : getIn18Text('CHAKANXIANGQING')),
                    React.createElement(Button, { inline: true, btnType: "link", style: { marginLeft: 0 }, hidden: !visible, onClick: e => {
                            e.stopPropagation();
                            refreshData();
                        }, size: "small" }, getIn18Text('SHUAXIN'))),
                visible ? (React.createElement("div", { style: { padding: '0 46px' } },
                    React.createElement(ConfigProvider, { renderEmpty: () => React.createElement("div", { className: "u-sticky-table-empty" }, getIn18Text('MEIYOUCHADAOXIANGQ，XTJBL60TNDHF、ZFXX。')) },
                        React.createElement(SiriusTable, { headerSplitColor: "#F5F5F5", className: "u-sticky-table", rowClassName: 'u-sticky-table-row', empty: true, loading: loading, columns: tableColumns, dataSource: historyData, pagination: false })))) : null))));
};
export default MailDeliveryHistory;
